import TaggedButton from '@components/TaggedButton';
import { useUploadSecondaryMarketTransactionsExcel } from '@modules/secondaryMarket/src/secondaryMarketMutations';
import { useSecondaryMarketTransactionsExcelTemplateDownload } from '@modules/secondaryMarket/src/secondaryMarketQueries';
import {
  Alert, Divider, Form,
  UploadProps,
} from 'antd';
import Paragraph from 'antd/es/typography/Paragraph';
import { FC, useState } from 'react';
import TaggedModal from '../../../components/TaggedModal';
import TaggedFileUpload from '../../../components/inputs/TaggedFileUpload';

interface UploadSecondaryMarketTransactionsExcelModalProps {
  closeModal: () => void;
  showModal: boolean;
}

const UploadSecondaryMarketTransactionsExcelModal: FC<UploadSecondaryMarketTransactionsExcelModalProps> = (props) => {
  const {
    closeModal, showModal,
  } = props;
  const [filelist, setFileList] = useState<Blob>();

  const { mutate: uploadTransactionsExcel, isLoading: uploadTransactionsExcelLoading } = useUploadSecondaryMarketTransactionsExcel(closeModal);
  const { refetch: downloadTemplate, isFetching: isDownloadTemplateLoading } = useSecondaryMarketTransactionsExcelTemplateDownload();

  const onUploadExcel = () => {
    const formData = new FormData();
    formData.append('file', filelist!);
    uploadTransactionsExcel(formData);
  };

  const uploadFileProps: UploadProps = {
    beforeUpload: (file) => {
      setFileList(file);
      return false;
    },
    maxCount: 1,
  };

  return (
    <TaggedModal
      open={showModal}
      tag="uploadExcel"
      title="Upload Secondary Market Transactions Excel"
      onCancel={closeModal}
      okText="Submit"
      okButtonProps={{
        htmlType: 'submit', form: 'uploadTransactionsExcel', loading: uploadTransactionsExcelLoading,
      }}
      destroyOnHidden
      centered
    >
      <Alert
        message="Notes:"
        type="info"
        description={
          (
            <>
              <Paragraph>
                <ul>
                  <li>Seller and buyer IDs correspond to the investor IDs.</li>
                  <li>Premium, discount, and fees and charges are in RM.</li>
                </ul>
              </Paragraph>
              <Paragraph>
                Click
                {' '}
                <TaggedButton tag="downloadExcel" size="small" onClick={() => downloadTemplate()} disabled={isDownloadTemplateLoading}>
                  HERE
                </TaggedButton>
                {' '}
                to download sample excel upload file.
              </Paragraph>
            </>
          )
        }
      />
      <Divider />

      <Form onFinish={onUploadExcel} id="uploadTransactionsExcel" layout="vertical">
        <Form.Item
          label="Only xlsx/csv file is allowed"
          name="transactionsExcel"
          rules={[{ required: true, message: 'Please upload a file' }]}
        >
          <TaggedFileUpload accept=".csv, .xlsx" tag="uploadTransactionsExcel" {...uploadFileProps} />
        </Form.Item>
      </Form>
    </TaggedModal>
  );
};

export default UploadSecondaryMarketTransactionsExcelModal;
